<div class="auth-highlights">
  <div class="auth-highlights__body">
    <!-- Text and image key off the same index, so both triggers run together.
         Each slide is created/destroyed by its own ngIf, which is what gives
         the :enter / :leave queries something to animate. -->
    <div class="auth-highlights__text" [@highlightText]="activeIndex">
      <ng-container *ngFor="let highlight of highlights; let i = index">
        <div class="auth-highlights__slide" *ngIf="i === activeIndex">
          <h2 class="auth-highlights__title">{{ highlight.titleKey | translate }}</h2>
          <p class="auth-highlights__desc">{{ highlight.descKey | translate }}</p>
        </div>
      </ng-container>
    </div>

  </div>

  <!-- Positioned out of flow: it starts at the card's centre and bleeds past
       the edge, so it must not contribute to the card's width. -->
  <div class="auth-highlights__image" [@highlightImage]="{ value: activeIndex, params: slideParams$ | async }">
    <ng-container *ngFor="let highlight of highlights; let i = index">
      <!-- The frame is what slides; the image only carries the RTL flip, which
           an animated transform on the same element would overwrite. -->
      <div class="auth-highlights__frame" *ngIf="i === activeIndex">
        <img class="auth-highlights__img" [src]="highlight.image" [alt]="highlight.titleKey | translate" />
      </div>
    </ng-container>
  </div>
</div>
